import { useQuery } from "@tanstack/react-query";
import { Colaborador } from "../../../../services/Colaborador";

export const useColaboradorAtual = (enabled = true) => {
  return useQuery({
    queryKey: ["colaborador-atual"],
    queryFn: () => Colaborador.atual(),
    select: (response) => response.data,
    enabled,
  });
};
